module.exports = __webpack_public_path__ + "img/react-native.86b46000.svg";